import { render, staticRenderFns } from "./allianceBusiness.vue?vue&type=template&id=21cd74ae&scoped=true"
import script from "./allianceBusiness.vue?vue&type=script&lang=js"
export * from "./allianceBusiness.vue?vue&type=script&lang=js"
import style0 from "./allianceBusiness.vue?vue&type=style&index=0&id=21cd74ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_71321242e37ff7a0c7584d931db29eba/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cd74ae",
  null
  
)

export default component.exports